import React from "react"
import ReactDOM from "react-dom/client"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import "./dagger.css"
import Dagger from "./dagger"

gsap.registerPlugin(ScrollTrigger)

const root = ReactDOM.createRoot(document.getElementById("dagger-root"))
root.render(<Dagger />)
